import React from 'react';
import PropTypes from 'prop-types';

export default class Counter extends React.Component {

  static propTypes = {
    count: PropTypes.number.isRequired,
    top: PropTypes.bool,
  };

  render() {

    let classname = "counter";
    if (this.props.top) {
      classname = "counter-top";
    }

    return (
      <div className={classname}>{this.props.count}</div>
    )
  }

}